import { Scene } from "onearm";
import { FullScreenBackgroundFill } from "onearm";

export class ErrorPopupScene extends Scene {
    constructor(parameters) {
        super({ name: 'ErrorPopupScene', layer: "popups", ...parameters });
        const { screen } = parameters;
        this.fill = this.addChildAt(
            new FullScreenBackgroundFill({
                fullScreenZone: screen.zone.fullScreen,
                color: 0x000000,
                alpha: 0.8,
            }),
            0,
        );
    }

    create(options) {
        super.create(options);
        const {
            title = "ERROR",
            message = "INTERNAL ERROR",
            showCloseButton = false,
            showReloadButton = true,
        } = options;
        this.layout = this.buildLayout("ErrorMessagePopup");
        this.closeButton = this.layout.find("CloseButton");
        this.reloadButton = this.layout.find("ReloadButton");

        this.errorText = this.layout.find("ErrorText");
        this.popupTitle = this.layout.find("PopupTitle");

        this.errorText.text = message;
        this.popupTitle.text = title;

        if (!showCloseButton) {
            this.closeButton.visible = false;
        }

        if (!showReloadButton) {
            this.reloadButton.visible = false;
        }
    }

    get onPressClose() {
        return this.closeButton.onPress;
    }

    get onPressReload() {
        return this.reloadButton.onPress;
    }
}
